import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/categories/page.tsx");
